import React from "react";
import { Multiselect } from "multiselect-react-dropdown";

export default function MultiSelect({ elem }) {
  return (
    <div className="mb-2">
      <label for="nombre">{elem.label}</label>
      <Multiselect
        options={elem.options}
        placeholder=""
        displayValue="name"
        name={elem.id}
        style={{
          chips: { background: "#2DE8BA", border: "0" },
          option: { background: "#2DE8BA", border: "0" },
          multiselectContainer: {
            background: "#EFEFEF",
            borderRadius: "12px",
          },
        }}
      />
    </div>
  );
}
